/**
 * Concept keys the front still needs to tell apart: the plan row leads its store and
 * discounts are pulled out of the rows.
 */
export const STORE_CONCEPT_KEYS = {
  license: 'plan',
  discount: 'discounts',
} as const;
